import {AdminPagingModel} from "./AdminPagingModel";
import {EmployeeService} from "../../services/EmployeeService";
import {PrintJobService} from "../../services/PrintJobService";
import {NotificationService} from "../../services/NotificationService";
import {GridBookmarkService} from "../../services/GridBookmarkService";
import {Template} from "../../entities/Template";
import {PrintJob} from "../../entities/PrintJob";
import {Employee} from "../../entities/Employee";

export class EmployeeAdminPagingModel extends AdminPagingModel<Employee>{
    static $inject = ['$q','EmployeeService','PrintJobService','NotificationService','GridBookmarkService'];
    constructor($q:ng.IQService, pagingService:EmployeeService,
                public printjobService:PrintJobService,
                public notificationService:NotificationService,
                gridBookmarkService:GridBookmarkService){
        super($q, pagingService,notificationService,gridBookmarkService);
    }
    getCustomActions():string[]{
        return [];
    }   
    entityName():string{
        return "employee";
    }
    displayName():string{
        return "Employees";
    }
    getColumnDefs():ng.IPromise<void>{
        this.nameValuePairs =
            [
                ['firstName', 'First Name', 150],
                ['lastName', 'Last Name', 150],
                ['email', 'Email', 150],
                ['phone', 'Phone', 150],
                ['rfidTag', 'RFID Tag', 215],
                ['lastSeen', 'Last Seen', 215],
                ['locationName', 'Location Name', 215],
                ['locationSite', 'Location Site', 215],
                ['locationBuilding', 'Location Building', 215],
                ['locationFloor', 'Location Floor', 215],
                ['locationRoom', 'Location Room', 215]
            ];
        return this.$q.when();
    }
}
